export interface Owner {
  id: string;
  name: string;
}

export class OwnerClass implements Owner {
  id: string;
  name: string;

  constructor(o: any = {}) {
    this.id = o['id'] ?? null;
    this.name = o['name'] ?? null;
  }
}
